import dayjs from 'dayjs';

import {
    CommonPromotionStatusEnum,
    PromotionDetailType,
    PromotionFormType,
    PromotionRequestType,
} from '../../../service/promotions/promotions-type';
import {ProvidersIdsEnum} from '../../../util/type';

export const PROMOTION_SELECT_COMPANIES_STEP_WIDTH = 864;
export const PROMOTION_MEDIA_STEP_WIDTH = 704;
export const PROMOTION_DETAILS_STEP_WIDTH = 704;

// Catalogs are hidden from the UI for now — promotions always target Yandex.
const PROMOTION_CATALOG_IDS = [ProvidersIdsEnum.yandex];

export function getPromotionFormInitialValues(promotion: PromotionDetailType): PromotionFormType {
    return {
        title: promotion.title,
        description: promotion.description,
        url: promotion.url,
        catalogsIds: promotion.catalogsIds,
        images: promotion.images,
        publishAt: promotion.publishAt ? dayjs(promotion.publishAt) : null,
        deletedAt: promotion.deletedAt ? dayjs(promotion.deletedAt) : null,
        startAt: promotion.startAt ? dayjs(promotion.startAt) : null,
        finishAt: promotion.finishAt ? dayjs(promotion.finishAt) : null,
    };
}

export function preparePromotionRequestData(
    values: PromotionFormType,
    selectorId: string,
    status: CommonPromotionStatusEnum
): PromotionRequestType {
    return {
        title: values.title,
        description: values.description ?? '',
        url: values.url ?? '',
        selectorId,
        catalogsIds: PROMOTION_CATALOG_IDS,
        publishAt: values.publishAt ? values.publishAt.toISOString() : null,
        deletedAt: values.deletedAt ? values.deletedAt.toISOString() : null,
        startAt: values.startAt ? values.startAt.toISOString() : '',
        finishAt: values.finishAt ? values.finishAt.toISOString() : '',
        imageIds: (values.images ?? []).map((image) => image.id),
        status,
    };
}
